import React, { useState, useContext } from "react";
import { VegaBox, VegaButtonLink } from "@heartlandone/vega-react";
import FeedbackPopup from "Components/AddFeedbackPopup/FeedbackPopup";
import { reloadActivitiesAction } from 'Redux/Actions/actions';
import { HubContext } from 'Redux/Context/context';

function AddFeedbackAction({ activity }) {
  const { id } = activity;
  const [isAddFeedbackOpen, setIsAddFeedbackOpen] = useState(false);
  const {  reloadActivitiesDispatch } = useContext(HubContext);
  const onFeedbackSubmit = () => {
    reloadActivitiesDispatch(
      reloadActivitiesAction({reloadBy: 'sumbit-feedback'})
    );
    setIsAddFeedbackOpen(false);
  };

  return (
    <VegaBox flexShrink={0} flexGrow={0}>
      <VegaButtonLink
        label="Add Feedback"
        icon="fa-regular fa-message-lines"
        onVegaClick={() => setIsAddFeedbackOpen(true)}
      />
      {
        <FeedbackPopup
          activityId={id}
          isOpen={isAddFeedbackOpen}
          onClose={() => {
            setIsAddFeedbackOpen(false);
          }}
          onSubmit={onFeedbackSubmit}
        />
      }
    </VegaBox>
  );
}

export default AddFeedbackAction;
